import React, { useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import assest from "../../json/assest";
import styles from "../../styles/layout/sidebar.module.scss";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  List,
  ListItem,
  Typography,
} from "@mui/material";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import SubMenu from "@imarabinda/antd/es/menu/SubMenu";
// import useNotiStack from "@/hooks/useNotistack";
// import { useAppDispatch } from "@/hooks/useAppDispatch";
import { useLocation, useNavigate } from "react-router-dom";

import ScrollBar from "react-perfect-scrollbar";
// import MenuDashboardIcon from "@/ui/Icons/MenuDashboardIcon";
import MenuSubmittedVideoIcon from "../../ui/Icons/MenuSubmittedVideoIcon";
import MenuPartnerIcon from "../../ui/Icons/MenuPartnerIcon";
import MenuMembersIcon from "../../ui/Icons/MenuMembersIcon";
import MenuContentBuyersIcon from "../../ui/Icons/MenuContentBuyersIcon";
import MenuManagerIcon from "../../ui/Icons/MenuManagerIcon";
import MenuQcAgentIcon from "../../ui/Icons/MenuQcAgentIcon";
import MenuCopywrittersIcon from "../../ui/Icons/MenuCopywrittersIcon";
import MenuEditorIcon from "../../ui/Icons/MenuEditorIcon";
import MenuAnalyticsIcon from "../../ui/Icons/MenuAnalyticsIcon";
import MenuNotification from "../../ui/Icons/MenuNotification";
import MenuMyMessageIcon from "../../ui/Icons/MenuMyMessageIcon";
import MenuSettingsIcon from "../../ui/Icons/MenuSettingsIcon";
import useNotiStack from "../../hooks/useNotistack";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import MenuDashboardIcon from "../../ui/Icons/MenuDashboardIcon";
import { logout } from "../../redux-toolkit/slices/userSlice";
import ReleaseIcons from "../../ui/Icons/ReleaseIcons";
import MenuClearVideoThinIcon from "../../ui/Icons/MenuClearVideoThinIcon";
import ReleaseThinIcon from "../../ui/Icons/ReleaseThinIcon";
import ReleaseBoldIcon from "../../ui/Icons/ReleaseBoldIcon";
import MenuClearVideoBoldIcon from "../../ui/Icons/MenuClearVideoBoldIcon";
import SidebarAccordian from "./SidebarAccordian";
import { matchPathname } from "../../lib/functions/utils.lib";
import { useAppSelector } from "../../hooks/useAppSelector";
import {
  setScrollSuperNav,
  setStopScroll,
} from "../../redux-toolkit/slices/app.state.slice";

const menuItems = [
  {
    heading: "Dashboard",
    icon: <MenuDashboardIcon />,
    link: "/",
  },
  {
    heading: "Submitted Videos",
    icon: <MenuSubmittedVideoIcon />,
    subMenuItems: [
      {
        heading: "Pending",
        icon: assest.Iconpending,
        link: "/pending",
      },
      {
        heading: "Inquiring",
        icon: assest.Iconinquiring,
        link: "/inquiring",
      },
      {
        heading: "Approved",
        icon: assest.Iconapprove,
        link: "/approved",
      },
      {
        heading: "Website Only",
        icon: assest.Iconwebsite,
        link: "/website",
      },
      {
        heading: "Duplications",
        icon: assest.Iconduplication,
        link: "/duplications",
      },
      {
        heading: "Rejected",
        icon: assest.Iconreject,
        link: "/rejected",
      },
      {
        heading: "Deleted",
        icon: assest.Icondelete,
        link: "/deleted",
      },
    ],
    link: "/pending",
  },
  {
    heading: "Cleared Videos",
    icon: <MenuClearVideoThinIcon />,
    icon2: <MenuClearVideoBoldIcon />,
    subMenuItems: [
      {
        heading: "Pending Titling",
        icon: assest.pendingTitlingIcon,
        link: "/clear-pending-titling",
      },
      {
        heading: "Pending Publication",
        icon: assest.pendingPublicationIcon,
        link: "/clear-pending-publication",
      },
      {
        heading: "Published",
        icon: assest.publishedicon,
        link: "/published",
      },
    ],
    link: "/clear-pending-titling",
  },
  {
    heading: "Released Videos",
    icon: <ReleaseThinIcon />,
    icon2: <ReleaseBoldIcon />,
    link: "/release-video",
  },
  {
    heading: "Partners",
    icon: <MenuPartnerIcon />,
    link: "/partners",
  },
  {
    heading: "Members",
    icon: <MenuMembersIcon />,
    link: "/members",
  },
  {
    heading: "Content Buyers",
    icon: <MenuContentBuyersIcon />,
    link: "/purchase-requests",
    subMenuItems: [
      {
        heading: "Buyers List",
        icon: assest.Notibuyer,
        link: "/buyers-list",
      },
      {
        heading: "Purchase Requests",
        icon: assest.purchaseReqstIcon,
        link: "/purchase-requests",
        additionalLinks: "request-details",
      },
    ],
  },
  {
    heading: "Managers",
    icon: <MenuManagerIcon />,
    link: "/managers",
  },
  {
    heading: "QC Agents",
    icon: <MenuQcAgentIcon />,
    link: "/qc-agents",
  },
  {
    heading: "Copywriters",
    icon: <MenuCopywrittersIcon />,
    link: "/copywriters",
  },
  {
    heading: "Editors",
    icon: <MenuEditorIcon />,
    link: "/editors",
  },
  {
    heading: "Analytics",
    icon: <MenuAnalyticsIcon />,
    link: "/analytics",
  },
  {
    heading: "Notifications",
    icon: <MenuNotification />,
    link: "/notification",
  },
  {
    heading: "My Messages",
    icon: <MenuMyMessageIcon />,
    subMenuItems: [
      {
        heading: "Messages",
        icon: assest.messageIcon,
        link: "/message",
      },
      {
        heading: "Support",
        icon: assest.supportIcon,
        link: "/support",
      },
    ],
    link: "/message",
  },
  {
    heading: "Settings",
    icon: <MenuSettingsIcon />,
    subMenuItems: [
      {
        heading: "My Account",
        icon: assest.myAccountIcon,
        link: "/myaccount",
      },
      {
        heading: "HUB Users",
        icon: assest.hubIcon,
        link: "/hubuser",
      },
    ],
    link: "/myaccount",
  },
];

const Sidebar = () => {
  const { toastSuccess } = useNotiStack();
  const dispatch = useAppDispatch();
  const [drop, setDrop] = useState(false);
  let { pathname } = useLocation();
  const [expanded, setExpanded] = React.useState(false);
  const [expandedTwo, setExpandedTwo] = React.useState(false);

  // console.warn("expanded", expanded);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
    // setExpanded(panel);
    // console.warn("expanded", panel);
    // setExpanded((pre) => !pre);
  };
  const handleChangeTwo = (panel) => {
    // console.warn("expanded2", panel);
    setExpandedTwo(panel);
  };

  const logoutFunc = () => {
    dispatch(logout());
    // toastSuccess("Logout Successful");
  };

  const navigate = useNavigate();
  // const router = useRouter();

  const { scrollSuperNav, stopScroll } = useAppSelector((s) => s.appStateSlice);
  const scrollBarRef = useRef(null);
  // const [stopScroll, setStopScroll] = useState(false);
  // console.log("scrollSuperNav", scrollSuperNav);
  useEffect(() => {
    if (scrollSuperNav > 20 || stopScroll) return;
    const solidPath = pathname.split("-")[0];
    dispatch(setStopScroll(true));
    const elementSelector = document.querySelectorAll(
      `.custom_scl a[href="${solidPath}"]`
    );
    // console.warn("elementSelector", elementSelector);
    if (scrollBarRef.current && elementSelector?.[0]) {
      const boundingRect = elementSelector?.[0]?.getBoundingClientRect();
      // console.log("boundingRect", boundingRect);
      setTimeout(() => {
        scrollBarRef.current.scrollTop = boundingRect.top - 490;
      }, 500);
    }
    // }, [pathname]);
  }, []);

  const onScroll = () => {
    const scrollTop = document.getElementById("test").scrollTop;
    dispatch(setScrollSuperNav(scrollTop));
  };

  useEffect(() => {
    if (scrollBarRef.current && scrollSuperNav > 20) {
      // scrollBarRef.current._container.scrollTop = scrollSuperNav;
      scrollBarRef.current.scrollTop = scrollSuperNav;
    }
  }, [scrollSuperNav]);
  return (
    <Box className={styles.sidebar_menu_box}>
      <Box className={styles.sidebar_menu}>
        <Box className={styles.sidebar_menu_inner}>
          <PerfectScrollbar
            className="custom_scl"
            id="test"
            // ref={scrollBarRef}
            containerRef={(container) => {
              scrollBarRef.current = container;
            }}
            onScroll={onScroll}
          >
            <List>
              {menuItems?.map((menu, index) => {
                const hasSubMenu =
                  menu?.subMenuItems && menu?.subMenuItems?.length > 0;
                const path = menu?.link;
                let isActive = false;
                if (path) {
                  // console.warn("path", path);
                  if (path === "/") {
                    if (pathname === "/") {
                      isActive = true;
                    }
                  } else {
                    isActive = pathname === path || pathname.includes(path);
                    // console.warn(path);
                  }
                }
                if (hasSubMenu) {
                  menu?.subMenuItems?.some((subMenu) => {
                    // console.warn("subMenu", subMenu);
                    if (subMenu.link) {
                      if (subMenu.link === "/") {
                        if (pathname === "/") {
                          isActive = true;
                        }
                      } else {
                        isActive =
                          pathname == subMenu.link ||
                          pathname.includes(subMenu.link) ||
                          pathname.includes(subMenu.additionalLinks);
                      }
                      return isActive;
                    }
                  });
                }
                return (
                  <ListItem
                    key={index}
                    className={`${isActive ? styles.active_menu : ""} ${
                      menu.heading === "Content Buyers" ? styles.badge : ""
                    } sidebar-${menu.heading.split(" ")[0]}`}
                  >
                    <a
                      href={menu?.link || "#"}
                      onClick={(e) => {
                        e.preventDefault();
                        if (!hasSubMenu && menu.link) {
                          navigate(menu.link);
                          handleChangeTwo("panel" + index);
                        } else {
                          navigate(menu.subMenuItems[0].link);
                          handleChangeTwo("panel" + index);
                        }
                      }}
                    >
                      <figure className={styles.side_menu}>
                        {/* <img
                          src={menu?.icon}
                          alt={menu?.heading}
                          width={menu?.iconWidth}
                          height={menu?.iconHeight}
                        /> */}
                        {/* {menu?.icon} */}
                        {isActive && menu.icon2 ? menu.icon2 : menu.icon}
                      </figure>
                      {!hasSubMenu ? (
                        <Typography
                          variant="caption"
                          className={styles.menuName}
                        >
                          {menu?.heading}
                        </Typography>
                      ) : null}
                    </a>
                    {hasSubMenu ? (
                      <>
                        <SidebarAccordian
                          isActive={isActive}
                          menu={menu}
                          index={index}
                        />
                      </>
                    ) : null}
                  </ListItem>
                );
              })}

              <ListItem className={styles.logout_btn} onClick={logoutFunc}>
                {/* <Link href="#"> */}
                <figure className={styles.side_menu}>
                  <img src={assest.menuicon15} alt="" width={23} height={20} />
                </figure>
                <Typography variant="caption" className={styles.menuName}>
                  Logout
                </Typography>
                {/* </Link> */}
              </ListItem>
            </List>
          </PerfectScrollbar>
        </Box>
      </Box>
    </Box>
  );
};

export default Sidebar;
